import React from 'react';
import { Button } from 'react-bootstrap';
import config from '../../config';

const MicrosoftLoginButton = () => {
  return (
    <Button
      variant="secondary"
      block
      onClick={() => {
        window.location.href = `${config.apiUrl}/oauth/azure/login`;
      }}
    >
      <i className="fab fa-microsoft" /> Microsoft Login
    </Button>
  );
};

export default MicrosoftLoginButton;
